var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorningRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 38.3253,
    r: 38.3253,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7344 47.3149H37.4407L35.9962 17.6723H42.1789L40.7344 47.3149ZM35.4761 55.8089C35.4761 54.3836 35.8228 53.3821 36.5162 52.8042C37.2096 52.2264 38.0571 51.9375 39.0587 51.9375C40.0217 51.9375 40.8499 52.2264 41.5433 52.8042C42.2752 53.3821 42.6412 54.3836 42.6412 55.8089C42.6412 57.1957 42.2752 58.1973 41.5433 58.8136C40.8499 59.43 40.0217 59.7382 39.0587 59.7382C38.0571 59.7382 37.2096 59.43 36.5162 58.8136C35.8228 58.1973 35.4761 57.1957 35.4761 55.8089Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorningRed);
export default __webpack_public_path__ + "static/media/WorningRed.66c128b6be34800b88b5df4675bde53f.svg";
export { ForwardRef as ReactComponent };